"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YellowBanner = void 0;
/* eslint-disable max-lines-per-function */
const summithill_models_1 = require("@clearsummit/summithill-models");
const defaults_1 = require("@clearsummit/summithill-models/lib/defaults");
const react_1 = __importStar(require("react"));
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const paywall_banner_1 = __importDefault(require("./paywall-banner"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const utils_1 = require("./utils");
const YellowBanner = ({ onClick, title, description, image, imageMobile, isGhostBtn, buttonTitle, hideButton, }) => (react_1.default.createElement("div", { className: styles_scss_1.default.stepBanner },
    react_1.default.createElement("div", { className: styles_scss_1.default.stepBannerImageCont },
        react_1.default.createElement("img", { className: styles_scss_1.default.image, src: image, alt: "banner" }),
        react_1.default.createElement("img", { className: styles_scss_1.default.imageMobile, src: imageMobile, alt: "banner" })),
    react_1.default.createElement("div", { className: styles_scss_1.default.stepBannerDescCont },
        react_1.default.createElement("h2", null, title),
        description && react_1.default.createElement("p", null, description),
        !hideButton && (react_1.default.createElement(components_1.Button, { title: buttonTitle, ariaLabel: buttonTitle, variant: isGhostBtn ? 'secondary-ghost' : 'secondary', onClick: onClick })))));
exports.YellowBanner = YellowBanner;
exports.YellowBanner.defaultProps = {
    description: '',
    isGhostBtn: false,
    onClick: undefined,
    hideButton: false,
    buttonTitle: '',
};
const StepBanner = ({ user, sections, activeStep, completeVideo, setVideoProgress, sessionStepOne, processQuestions, processQuestionsSummary, program, setActiveStep, setExpandedSection, }) => {
    var _a;
    const player = react_1.useRef(null);
    const [videoDuration, setVideoDuration] = react_1.useState(0);
    const { step, sectionId } = activeStep || {};
    if ((user === null || user === void 0 ? void 0 : user.paywallActive) && sectionId && utils_1.shouldShowPaywallBanner(sectionId, sections)) {
        return (react_1.default.createElement(paywall_banner_1.default, { sections: sections, setActiveStep: setActiveStep, setExpandedSection: setExpandedSection }));
    }
    if (step instanceof summithill_models_1.Video) {
        return (react_1.default.createElement(components_1.VideoPlayer, { ref: player, id: (_a = activeStep === null || activeStep === void 0 ? void 0 : activeStep.step) === null || _a === void 0 ? void 0 : _a.id, style: styles_scss_1.default.noMarginTop, url: step.url, title: step.name, onDuration: (duration) => setVideoDuration(duration), onProgress: (state) => {
                if (videoDuration > 0) {
                    const { playedSeconds } = state;
                    const progress = Math.round((playedSeconds / videoDuration) * 100);
                    setVideoProgress(progress);
                }
            }, onEnded: () => {
                if (sectionId) {
                    completeVideo({ sectionId, videoId: step.id });
                    setVideoProgress(0);
                }
            } }));
    }
    if (step instanceof summithill_models_1.ProcessQuestion) {
        if (step.completed) {
            return (react_1.default.createElement(exports.YellowBanner, { title: constants_1.default.program.processQuestions, description: constants_1.default.program.youHaveCompleted, image: constants_1.Images.undrawCheckList, imageMobile: constants_1.Images.undrawCheckListMobile, onClick: () => {
                    processQuestionsSummary({
                        questions: step.questions,
                    });
                }, buttonTitle: constants_1.default.program.checkyAnswers }));
        }
        return (react_1.default.createElement(exports.YellowBanner, { title: constants_1.default.program.processQuestions, description: constants_1.default.program.processQuestionsDescription, image: constants_1.Images.undrawBookLover, imageMobile: constants_1.Images.undrawBookLoverMobile, onClick: () => {
                processQuestions({
                    questions: step.questions,
                    sectionId: activeStep === null || activeStep === void 0 ? void 0 : activeStep.sectionId,
                    processQuestionId: step.id,
                    programId: program.id,
                });
            }, buttonTitle: constants_1.default.program.completeNow }));
    }
    if (step instanceof summithill_models_1.Session) {
        const sessionType = defaults_1.snakeToCamel(step.sessionType);
        const title = constants_1.default.program.sessionType[sessionType];
        const text = sessionType === 'therapy'
            ? constants_1.default.program.pleaseBookYourTherapy
            : constants_1.default.program.pleaseBookYourCaseManagement;
        const onClick = () => {
            sessionStepOne({ type: sessionType });
        };
        if (step.completed) {
            return (react_1.default.createElement(exports.YellowBanner, { title: step.sessionType === summithill_models_1.SessionType.CASE_MANAGEMENT
                    ? constants_1.default.program.comepletedCaseManagement
                    : constants_1.default.program.completedTherapySession, description: step.sessionType === summithill_models_1.SessionType.CASE_MANAGEMENT
                    ? constants_1.default.program.comepletedCaseManagementText
                    : constants_1.default.program.completedTherapySessionText, image: constants_1.Images.undrawCheckList, imageMobile: constants_1.Images.undrawCheckListMobile, hideButton: true }));
        }
        return (react_1.default.createElement(exports.YellowBanner, { title: title, description: text, image: constants_1.Images.undrawBooking, imageMobile: constants_1.Images.undrawBookingMobile, onClick: onClick, buttonTitle: constants_1.default.program.bookOrReschedule }));
    }
    return react_1.default.createElement("div", { className: styles_scss_1.default.bannerContainer });
};
exports.default = StepBanner;
